export default{

    setPlayerState : (state, data) => {
        state.player = data
    }
}